"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMockTerm = void 0;
var IRVar_1 = require("../../../../../IR/IRNodes/IRVar.js");
var Term_1 = require("../../../../Term/index.js");
var mockTermIr = Object.freeze(new IRVar_1.IRVar(0));
function genMockTermIr(_dbn) {
    return mockTermIr;
}
function makeMockTerm(t) {
    return new Term_1.Term(t, genMockTermIr);
}
exports.makeMockTerm = makeMockTerm;
